import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SiftScreenEnum } from '../filter/model';
import { RootState } from '../root/root-types';

export const REPORT_FILTER_API_FEATURE_KEY = 'reportFilterApiData';

type ReportFilterApiState = {
  byScreen: Partial<Record<SiftScreenEnum, Record<string, any>>>;
};

const initialState: ReportFilterApiState = {
  byScreen: {},
};

export const reportFilterApiSlice = createSlice({
  name: REPORT_FILTER_API_FEATURE_KEY,
  initialState,
  reducers: {
    setReportFilterApiResponse: (
      state,
      action: PayloadAction<{
        screen: SiftScreenEnum;
        response: Record<string, any> | undefined;
      }>
    ) => {
      const { screen, response } = action.payload;
      if (!screen || !response) return;
      state.byScreen[screen] = response;
    },
    clearReportFilterApiResponseByScreen: (
      state,
      action: PayloadAction<{ screen: SiftScreenEnum }>
    ) => {
      if (!action.payload.screen) return;
      delete state.byScreen[action.payload.screen];
    },
    clearAllReportFilterApiResponses: (state) => {
      state.byScreen = {};
    },
  },
});

export const {
  setReportFilterApiResponse,
  clearReportFilterApiResponseByScreen,
  clearAllReportFilterApiResponses,
} = reportFilterApiSlice.actions;

export const getAllReportFilterApiResponses = (state: RootState) =>
  (state as any)[REPORT_FILTER_API_FEATURE_KEY]?.byScreen || {};

export const getReportFilterApiResponseByScreen = (
  screen: SiftScreenEnum | undefined
) =>
  createSelector(getAllReportFilterApiResponses, (byScreen) =>
    screen ? byScreen?.[screen] : undefined
  );
